import AabTable from './AabTable';

customElements.define('aab-simple-table', AabTable);
